import styled from 'styled-components';
import { v2Colors, v2FontFamily, v2Breakpoints } from '../../../../formInputsV2/styles/tokens';
import { CollapsibleToggleRow, CollapsibleBody } from '../../../../formInputsV2/CollapsiblePanel.styles';

export const ResultOverviewGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 3fr);
  gap: 16px;

  @media (max-width: ${v2Breakpoints.tablet}) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

export const Card = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
  background: ${v2Colors.inputBackground};
  border: 1px solid ${v2Colors.border};
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(16, 24, 40, 0.06);
  font-family: ${v2FontFamily};

  @media (max-width: ${v2Breakpoints.tablet}) {
    padding: 14px 16px;
  }
`;

// Wraps a CollapsiblePanel: on tablet/desktop its toggle button is hidden
// and its body forced open, so the panel only actually collapses on mobile
// where the vertical space it saves is what keeps the quote cards below
// visible without scrolling.
export const AlwaysOpenAtDesktop = styled.div`
  @media (min-width: ${v2Breakpoints.tablet}) {
    ${CollapsibleToggleRow} {
      display: none;
    }

    ${CollapsibleBody} {
      grid-template-rows: 1fr !important;
    }
  }
`;
